/* eslint-disable max-lines */
/* eslint-disable no-invalid-this */
/* eslint-disable camelcase */
import { extend } from "lodash";
import { action, extendObservable, extendShallowObservable } from "mobx";

export interface FiltersState {
  ami: string;
  ami_0br_40: boolean;
  ami_0br_50: boolean;
  ami_1br_40: boolean;
  ami_1br_50: boolean;
  ami_2br_40: boolean;
  ami_2br_50: boolean;
  ami_3br_40: boolean;
  ami_3br_50: boolean;
  applicant_dob_max: string;
  applicant_dob_min: string;
  applicant_dob_over_55: boolean;
  applicant_rental_buy_pref: string,
  custom_pref_1_inverse: boolean;
  custom_pref_1: boolean;
  custom_pref_10_inverse: boolean;
  custom_pref_10: boolean;
  custom_pref_11_inverse: boolean;
  custom_pref_11: boolean;
  custom_pref_12_inverse: boolean;
  custom_pref_12: boolean;
  custom_pref_13_inverse: boolean;
  custom_pref_13: boolean;
  custom_pref_14_inverse: boolean;
  custom_pref_14: boolean;
  custom_pref_2_inverse: boolean;
  custom_pref_2: boolean;
  custom_pref_3_inverse: boolean;
  custom_pref_3: boolean;
  custom_pref_4_inverse: boolean;
  custom_pref_4: boolean;
  custom_pref_5_inverse: boolean;
  custom_pref_5: boolean;
  custom_pref_6_inverse: boolean;
  custom_pref_6: boolean;
  custom_pref_7_inverse: boolean;
  custom_pref_7: boolean;
  custom_pref_8_inverse: boolean;
  custom_pref_8: boolean;
  custom_pref_9_inverse: boolean;
  custom_pref_9: boolean;
  has_star_inverse: boolean;
  has_star: boolean;
  has_position_number: boolean;
  has_user_id_inverse: boolean;
  has_user_id: boolean;
  has_document: boolean;
  has_document_inverse: boolean;
  house_member_wheelchair: boolean;
  household_all_full_time_students: boolean;
  household_ami: string;
  household_count_max: string;
  household_count_min: string;
  household_has_housing_authority_voucher_inverse: boolean;
  household_has_housing_authority_voucher: boolean;
  household_has_special_accommodations: boolean;
  household_income_max: string;
  household_income_min: string;
  household_lives_in_palo_alto: boolean;
  household_lives_works_in_alameda: boolean;
  household_lives_works_in_menlo_park: boolean;
  household_lives_works_in_san_carlos: boolean;
  household_lives_works_in_san_mateo: boolean;
  household_lives_works_in_south_sf: boolean;
  household_receives_other_housing_assistance: boolean;
  household_receives_other_housing_assistance_inverse: boolean;
  household_requires_impairment_hearing: boolean;
  household_requires_impairment_mobility: boolean;
  household_requires_impairment_visual: boolean;
  household_served_in_armed_forces: boolean;
  household_works_in_palo_alto: boolean;
  position_number: string;
  statuses: string[];
  available_statuses: string[];
  unit_size_1br: boolean;
  unit_size_1br_den: boolean;
  unit_size_2br: boolean;
  unit_size_3br: boolean;
  unit_size_4br: boolean;
  unit_size_5br: boolean;
  unit_size_sro: boolean;
  unit_size_studio: boolean;
  unit_size_shared: boolean;
  household_member_0_gender: string;
}

const defaultState: FiltersState = {
  ami: "all",
  ami_0br_40: false,
  ami_0br_50: false,
  ami_1br_40: false,
  ami_1br_50: false,
  ami_2br_40: false,
  ami_2br_50: false,
  ami_3br_40: false,
  ami_3br_50: false,
  applicant_rental_buy_pref: "",
  applicant_dob_max: "",
  applicant_dob_min: "",
  applicant_dob_over_55: false,
  custom_pref_1_inverse: false,
  custom_pref_1: false,
  custom_pref_10_inverse: false,
  custom_pref_10: false,
  custom_pref_11_inverse: false,
  custom_pref_11: false,
  custom_pref_12_inverse: false,
  custom_pref_12: false,
  custom_pref_13_inverse: false,
  custom_pref_13: false,
  custom_pref_14_inverse: false,
  custom_pref_14: false,
  custom_pref_2_inverse: false,
  custom_pref_2: false,
  custom_pref_3_inverse: false,
  custom_pref_3: false,
  custom_pref_4_inverse: false,
  custom_pref_4: false,
  custom_pref_5_inverse: false,
  custom_pref_5: false,
  custom_pref_6_inverse: false,
  custom_pref_6: false,
  custom_pref_7_inverse: false,
  custom_pref_7: false,
  custom_pref_8_inverse: false,
  custom_pref_8: false,
  custom_pref_9_inverse: false,
  custom_pref_9: false,
  has_star_inverse: false,
  has_star: false,
  has_position_number: false,
  has_user_id_inverse: false,
  has_user_id: false,
  has_document_inverse: false,
  has_document: false,
  house_member_wheelchair: false,
  household_all_full_time_students: false,
  household_ami: "",
  household_count_max: "",
  household_count_min: "",
  household_has_housing_authority_voucher_inverse: false,
  household_has_housing_authority_voucher: false,
  household_has_special_accommodations: false,
  household_income_max: "",
  household_income_min: "",
  household_lives_in_palo_alto: false,
  household_lives_works_in_alameda: false,
  household_lives_works_in_menlo_park: false,
  household_lives_works_in_san_carlos: false,
  household_lives_works_in_san_mateo: false,
  household_lives_works_in_south_sf: false,
  household_receives_other_housing_assistance: false,
  household_receives_other_housing_assistance_inverse: false,
  household_requires_impairment_hearing: false,
  household_requires_impairment_mobility: false,
  household_requires_impairment_visual: false,
  household_served_in_armed_forces: false,
  household_works_in_palo_alto: false,
  position_number: "",
  statuses: [],
  available_statuses: [],
  unit_size_1br: false,
  unit_size_1br_den: false,
  unit_size_2br: false,
  unit_size_3br: false,
  unit_size_4br: false,
  unit_size_5br: false,
  unit_size_sro: false,
  unit_size_studio: false,
  unit_size_shared: false,
  household_member_0_gender: "",
};

class SidebarState implements FiltersState {
  constructor () {
    this.reset();
  }

  ami: string = defaultState.ami;

  ami_0br_40: boolean = defaultState.ami_0br_40;

  ami_0br_50: boolean = defaultState.ami_0br_50;

  ami_1br_40: boolean = defaultState.ami_1br_40;

  ami_1br_50: boolean = defaultState.ami_1br_50;

  ami_2br_40: boolean = defaultState.ami_2br_40;

  ami_2br_50: boolean = defaultState.ami_2br_50;

  ami_3br_40: boolean = defaultState.ami_3br_40;

  ami_3br_50: boolean = defaultState.ami_3br_50;

  applicant_dob_max: string = defaultState.applicant_dob_max;

  applicant_dob_min: string = defaultState.applicant_dob_min;

  applicant_dob_over_55: boolean = defaultState.applicant_dob_over_55;

  applicant_rental_buy_pref: string = defaultState.applicant_rental_buy_pref;

  custom_pref_1_inverse: boolean = defaultState.custom_pref_1_inverse;

  custom_pref_1: boolean = defaultState.custom_pref_1;

  custom_pref_10_inverse: boolean = defaultState.custom_pref_10_inverse;

  custom_pref_10: boolean = defaultState.custom_pref_10;

  custom_pref_11_inverse: boolean = defaultState.custom_pref_11_inverse;

  custom_pref_11: boolean = defaultState.custom_pref_11;

  custom_pref_12_inverse: boolean = defaultState.custom_pref_12_inverse;

  custom_pref_12: boolean = defaultState.custom_pref_12;

  custom_pref_13_inverse: boolean = defaultState.custom_pref_13_inverse;

  custom_pref_13: boolean = defaultState.custom_pref_13;

  custom_pref_14_inverse: boolean = defaultState.custom_pref_14_inverse;

  custom_pref_14: boolean = defaultState.custom_pref_14;

  custom_pref_2_inverse: boolean = defaultState.custom_pref_2_inverse;

  custom_pref_2: boolean = defaultState.custom_pref_2;

  custom_pref_3_inverse: boolean = defaultState.custom_pref_3_inverse;

  custom_pref_3: boolean = defaultState.custom_pref_3;

  custom_pref_4_inverse: boolean = defaultState.custom_pref_4_inverse;

  custom_pref_4: boolean = defaultState.custom_pref_4;

  custom_pref_5_inverse: boolean = defaultState.custom_pref_5_inverse;

  custom_pref_5: boolean = defaultState.custom_pref_5;

  custom_pref_6_inverse: boolean = defaultState.custom_pref_6_inverse;

  custom_pref_6: boolean = defaultState.custom_pref_6;

  custom_pref_7_inverse: boolean = defaultState.custom_pref_7_inverse;

  custom_pref_7: boolean = defaultState.custom_pref_7;

  custom_pref_8_inverse: boolean = defaultState.custom_pref_8_inverse;

  custom_pref_8: boolean = defaultState.custom_pref_8;

  custom_pref_9_inverse: boolean = defaultState.custom_pref_9_inverse;

  custom_pref_9: boolean = defaultState.custom_pref_9;

  has_star_inverse: boolean = defaultState.has_star_inverse;

  has_star: boolean = defaultState.has_star;

  has_position_number: boolean = defaultState.has_position_number;

  has_user_id_inverse: boolean = defaultState.has_user_id_inverse;

  has_user_id: boolean = defaultState.has_user_id;

  has_document: boolean = defaultState.has_document;

  has_document_inverse: boolean = defaultState.has_document_inverse;

  house_member_wheelchair: boolean = defaultState.house_member_wheelchair;

  household_all_full_time_students: boolean = defaultState.household_all_full_time_students;

  household_ami: string = defaultState.household_ami;

  household_count_max: string = defaultState.household_count_max;

  household_count_min: string = defaultState.household_count_min;

  household_has_housing_authority_voucher_inverse: boolean =
  defaultState.household_has_housing_authority_voucher_inverse;

  household_has_housing_authority_voucher: boolean =
  defaultState.household_has_housing_authority_voucher;

  household_has_special_accommodations: boolean = defaultState.household_has_special_accommodations;

  household_income_max: string = defaultState.household_income_max;

  household_income_min: string = defaultState.household_income_min;

  household_lives_in_palo_alto: boolean = defaultState.household_lives_in_palo_alto;

  household_lives_works_in_alameda: boolean = defaultState.household_lives_works_in_alameda;

  household_lives_works_in_menlo_park: boolean = defaultState.household_lives_works_in_menlo_park;

  household_lives_works_in_san_carlos: boolean = defaultState.household_lives_works_in_san_carlos;

  household_lives_works_in_san_mateo: boolean = defaultState.household_lives_works_in_san_mateo;

  household_lives_works_in_south_sf: boolean = defaultState.household_lives_works_in_south_sf;

  household_receives_other_housing_assistance: boolean =
  defaultState.household_receives_other_housing_assistance;

  household_receives_other_housing_assistance_inverse: boolean =
  defaultState.household_receives_other_housing_assistance_inverse;

  household_requires_impairment_hearing: boolean =
  defaultState.household_requires_impairment_hearing;

  household_requires_impairment_mobility: boolean =
  defaultState.household_requires_impairment_mobility;

  household_requires_impairment_visual: boolean =
  defaultState.household_requires_impairment_visual;

  household_served_in_armed_forces: boolean =
  defaultState.household_served_in_armed_forces;

  household_works_in_palo_alto: boolean =
  defaultState.household_works_in_palo_alto;

  position_number: string = defaultState.position_number;

  statuses: string[] = defaultState.statuses;

  available_statuses: string[] = defaultState.available_statuses;

  unit_size_1br: boolean = defaultState.unit_size_1br;

  unit_size_1br_den: boolean = defaultState.unit_size_1br_den;

  unit_size_2br: boolean = defaultState.unit_size_2br;

  unit_size_3br: boolean = defaultState.unit_size_3br;

  unit_size_4br: boolean = defaultState.unit_size_4br;

  unit_size_5br: boolean = defaultState.unit_size_5br;

  unit_size_sro: boolean = defaultState.unit_size_sro;

  unit_size_studio: boolean = defaultState.unit_size_studio;

  unit_size_shared: boolean = defaultState.unit_size_shared;

  household_member_0_gender: string = defaultState.household_member_0_gender;

  reset = action(() => {
    extendObservable(this, extend({}, defaultState));
  });

  load = action((state: FiltersState) => {
    extendShallowObservable(this, state);
  });

  updateKey = action((key: keyof FiltersState, value: string | boolean | string[]) => {
    if (Object.prototype.hasOwnProperty.call(this, key)) {
      // @ts-ignore
      this[key as keyof SidebarState] = value;
    } else {
      console.error("Key does not exist:", key);
    }
  });
}
export const sidebarState = new SidebarState();
